const User = {
  CREATED_SUCCESS: 'The user has been created successfully',
  UPDATED_SUCCESS: 'The user details has been updated successfully',
  CREATE_FAILURE: 'Unable to create a user. Please try again',
  DELETE_SUCCESS: 'The user account has been deleted successfully',
  DELETE_FAILURE: 'Unable to delete a user. Please try again',
  ACTIVE_INACTIVE_SUCCESS:
    'The user account has been made {{placeholder}} successfully',
  ACTIVE_INACTIVE_FAILURE:
    'Unable to make the user as {{placeholder}}. Please try again',
};

const Stores = {
  CREATED_SUCCESS: 'The Stores has been Created successfully',
  UPDATED_SUCCESS: 'The Stores has been Updated successfully',
  UPDATE_FAILURE:
    'Something went wrong the Stores not upadated. Please try again',
  CREATE_FAILURE:
    'Something went wrong the Stores not created. Please try again',
};
const Tier = {
  CREATED_SUCCESS: 'The Default Tier has been Created successfully',
  UPDATED_SUCCESS: 'The Default Tier has been Updated successfully',
  UPDATE_FAILURE:
    'Something went wrong the Default Tier not upadated. Please try again',
  CREATE_FAILURE:
    'Something went wrong the Default Tier not created. Please try again',
};
const FestiveTier = {
  CREATED_SUCCESS: 'The Festive Tier has been Created successfully',
  UPDATED_SUCCESS: 'The Festive Tier has been Updated successfully',
  UPDATE_FAILURE:
    'Something went wrong the Festive Tier not upadated. Please try again',
};

const Voucher = {
  CREATED_SUCCESS: 'The Voucher has been Created successfully',
  UPDATED_SUCCESS: 'The Voucher has been Updated successfully',
  UPDATE_FAILURE:
    'Something went wrong the Voucher not upadated. Please try again',
  CREATE_FAILURE:
    'Something went wrong the Voucher not created. Please try again',
};
const Package = {
  CREATED_SUCCESS: 'The Bundle has been Created successfully',
  UPDATED_SUCCESS: 'The Bundle has been Updated successfully',
  DELETED_SUCCESS: 'The Bundle has been Deleted successfully',
  MIN_ONE_VOUCHER: 'Add at least one voucher to this bundle.',
  PICK_STORE: 'Pick a store.',
  PICK_DATES: "Set this voucher's start and expiry dates.",
  MALL_CHANGE_WARNING:
    "Changing the mall will clear every voucher's store and the tier selection. Continue?",
  ALREADY_BOUGHT_DELETE: 'Already bought — switch Status off instead.',
  ALREADY_BOUGHT_REMOVE: "Already bought — can't be removed.",
  CANCEL_CONFIRM: 'Are you sure?',
  NOTHING_COLLECTED:
    'Nothing was collected. Fix the highlighted vouchers and try again.',
  EXPORT_STARTED: 'Bundle export started. The file will download shortly.',
  EXPORT_READY: 'Bundle export is ready.',
};
const Menus = {
  CREATED_SUCCESS: 'The Menus has been Created successfully',
  UPDATED_SUCCESS: 'The Menus has been Updated successfully',
  UPDATE_FAILURE:
    'Something went wrong the Menus not upadated. Please try again',
  CREATE_FAILURE:
    'Something went wrong the Menus not created. Please try again',
};

const Mall = {
  CREATED_SUCCESS: 'The Mall has been Created successfully',
  UPDATED_SUCCESS: 'The Mall has been Updated successfully',
  UPDATE_FAILURE:
    'Something went wrong the Mall not upadated. Please try again',
  CREATE_FAILURE: 'Something went wrong the Mall not created. Please try again',
};
const Support_Service = {
  CREATED_SUCCESS: 'The Support Service has been Created successfully',
  UPDATED_SUCCESS: 'The Support Service has been Updated successfully',
  UPDATE_FAILURE:
    'Something went wrong the Support Service not upadated. Please try again',
  CREATE_FAILURE:
    'Something went wrong the Support Service not created. Please try again',
};

const MallBanner = {
  CREATED_SUCCESS: 'The Mall Banner has been Created successfully',
  UPDATED_SUCCESS: 'The Mall Banner has been Updated successfully',
  UPDATE_FAILURE:
    'Something went wrong the Mall Banner not upadated. Please try again',
  CREATE_FAILURE:
    'Something went wrong the Mall Banner not created. Please try again',
};
const Events = {
  CREATED_SUCCESS: 'The Event has been Created successfully',
  UPDATED_SUCCESS: 'The Event has been Updated successfully',
  UPDATE_FAILURE:
    'Something went wrong the Event not upadated. Please try again',
  CREATE_FAILURE:
    'Something went wrong the Event not created. Please try again',
};
const Permission = {
  CREATED_SUCCESS: 'The Permission has been Created successfully',
  UPDATED_SUCCESS: 'The Permission has been Updated successfully',
  UPDATE_FAILURE:
    'Something went wrong the Permission not upadated. Please try again',
  CREATE_FAILURE:
    'Something went wrong the Permission not created. Please try again',
};
const Offers = {
  CREATED_SUCCESS: 'The Offers has been Created successfully',
  UPDATED_SUCCESS: 'The Offers has been Updated successfully',
  UPDATE_FAILURE:
    'Something went wrong the Offers not upadated. Please try again',
  CREATE_FAILURE:
    'Something went wrong the Offers not created. Please try again',
};
const Notifications = {
  CREATED_SUCCESS: 'The Notifications has been Created successfully',
  UPDATED_SUCCESS: 'The Notifications has been Updated successfully',
  UPDATE_FAILURE:
    'Something went wrong the Notifications not upadated. Please try again',
  CREATE_FAILURE:
    'Something went wrong the Notifications not created. Please try again',
};
const video = {
  VIDEO_SUCCESS: 'Video content created Successfully',
  VIDEO_FAIL: 'Failed to create content',
};
const Login = {
  LOGIN_SUCCESS: 'Logged in successfully',
  LOGIN_FAILURE:
    'Unable to login. This could be due invalid credential. Please try again',
};

const Password = {
  UPDATE_SUCCESS: 'The password has been updated successfully',
  CHECK_EMAIL: 'Check your Email. Reset password link will be there',
  UPDATE_FAILURE: 'Unable to update the password. Please try again',
};

const Error = {
  COMMON_MESSAGE:
    'We’re so sorry. Looks like something went wrong. Please try again.',
};

const Customer = {
  STATUS_UPDATED_SUCCESS: 'The Customer status has been Updated successfully',
  STATUS_BLOCKED_SUCCESS: 'Customer blocked successfully',
  STATUS_UNBLOCKED_SUCCESS: 'Customer unblocked successfully',
  STATUS_RESTORED_SUCCESS: 'Customer restored successfully',
  STATUS_UPDATED_FAILURE:
    'Something went wrong, the Customer status was not updated. Please try again',
};

const Feedback = {
  CREATED_SUCCESS: 'Feedback has been created successfully',
  UPDATED_SUCCESS: 'Feedback has been updated successfully',
};

const Campaign = {
  CREATED_SUCCESS: 'The Campaign has been Created successfully',
  UPDATED_SUCCESS: 'The Campaign has been Updated successfully',
  TARGETING_DUPLICATE_PAIR:
    'Two targeting entries cannot point at the same Mall and Tier',
  // Shown when an admin tries to switch Publish back on for a campaign whose
  // end date has already passed. Republishing does nothing there — the
  // backend derives ENDED from the end date and it outranks the publish flag
  // (GamificationCampaignService.deriveCampaignStatus) — so the end date is
  // the thing that has to change first.
  PUBLISH_AFTER_END_DATE:
    'This campaign has expired and cannot be published. Extend the Campaign End Date, or switch Publish off to save your other changes.',
};

const Message = {
  Login,
  Error,
  User,
  Password,
  video,
  Stores,
  Menus,
  Mall,
  Support_Service,
  Events,
  MallBanner,
  Tier,
  FestiveTier,
  Permission,
  Voucher,
  Package,
  Offers,
  Customer,
  Feedback,
  Notifications,
  Campaign,
};

export default Message;
